import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import * as R from 'ramda';

import useAPI from '@/hooks/useAPI';
import {myPlans} from '@/b2c/api';
import {
  PlanCategoryList,
  PlanCategoryListRwd,
} from '@/b2c/PlanDetail/PlanCategoryList';
// import ApplyForm from '@/b2c/PlanDetail/ApplyForm';
import Statement from '@/b2c/PlanDetail/Statement';
import Tab from '@/b2c/PlanDetail/Tab';

const PlanDetail = ({match}) => {
  const {result, trigger, error} = useAPI(myPlans, {pending: true});
  const plans = R.defaultTo([], R.prop('data', result));
  const currentPlan = R.find(R.propEq('id', parseInt(match.params.id, 10)))(
    plans
  );
  const {t: tr, i18n} = useTranslation('planDetail');

  const skipFormDownload =
    currentPlan && currentPlan.policyStatusCode
      ? R.includes(currentPlan.policyStatusCode, [
          'COF', // cool offed
          'CAN', // cancelled
          'LAP', // lapsed
          'SUR', // surrendered
          'TOT', // transferred out
        ])
      : false;

  useEffect(() => {
    trigger();
  }, i18n.language);

  if (error) {
    return (
      <div>
        <h1>Fail fetching data</h1>
        <p>{String(error)}</p>
      </div>
    );
  }

  if (!currentPlan) {
    return null;
  }

  return (
    <div className='row'>
      <aside className='col-md-3 col-sm-12'>
        <ul className='wide'>
          <PlanCategoryList plans={plans} />
        </ul>
        <div className='narrow'>
          <h1>{tr('title')}</h1>
          <PlanCategoryListRwd currentPlan={currentPlan} plans={plans} />
        </div>
      </aside>
      <article className='col-md-9 col-sm-12'>
        <h2>{currentPlan.productName}</h2>
        <Statement plan={currentPlan} skipFormDownload={skipFormDownload} />
        <Tab plan={currentPlan} skipFormDownload={skipFormDownload} />
      </article>
    </div>
  );
};

export default PlanDetail;
